<div class="typed-confirm-dialog">

  <!-- ── Header ─────────────────────────────────────────────────────────── -->
  <div class="dialog-header">
    <i [class]="styling.iconClass" [style.color]="styling.iconColor"></i>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>

  <!-- ── Body ──────────────────────────────────────────────────────────── -->
  <div mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ data.message }}</p>

    <ul *ngIf="data.details && data.details.length" class="detail-list">
      <li *ngFor="let detail of data.details">{{ detail }}</li>
    </ul>

    <div *ngIf="data.overflowHoverLabel && data.overflowHoverText" class="overflow-hint-wrap">
      <span class="overflow-hint-label">Additional selection:</span>
      <span class="overflow-hint-chip" [matTooltip]="data.overflowHoverText" matTooltipPosition="above">
        {{ data.overflowHoverLabel }}
      </span>
    </div>

    <!-- Visible phrase instruction — always shows the exact phrase(s); replaces placeholder-only approach -->
    <div class="phrase-instruction">
      <span class="phrase-instruction__label">To confirm, type exactly:</span>
      <div class="phrase-instruction__chips">
        <code class="phrase-chip phrase-chip--primary">{{ data.confirmPhrase }}</code>
        <ng-container *ngIf="data.secondaryOption">
          <span class="phrase-chip__sep">or</span>
          <code class="phrase-chip phrase-chip--secondary">{{ data.secondaryOption.phrase }}</code>
        </ng-container>
      </div>
    </div>

    <!-- Phrase input -->
    <div class="phrase-input-group">
      <input
        class="phrase-input"
        type="text"
        placeholder="Type here to confirm"
        [(ngModel)]="typedInput"
        (keydown)="onKeyDown($event)"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
      />
    </div>

    <!-- Confirmation summary — visible once a phrase is matched -->
    <div class="confirm-summary"
         *ngIf="activeSummary"
         [class.confirm-summary--secondary]="activeSummaryVariant === 'secondary'">
      <mat-icon class="confirm-summary-icon">{{ activeSummaryVariant === 'secondary' ? 'warning' : 'info' }}</mat-icon>
      <span>{{ activeSummary }}</span>
    </div>
  </div>

  <!-- ── Actions ───────────────────────────────────────────────────────── -->
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button class="cancel-btn" (click)="onCancel()">
      {{ data.cancelText }}
    </button>

    <div class="action-btns">
      <!-- Primary confirm (orange warn) -->
      <button
        mat-raised-button
        color="warn"
        class="confirm-btn"
        [disabled]="!isConfirmEnabled"
        (click)="onConfirm()"
      >
        {{ data.confirmButtonText }}
      </button>

      <!-- Secondary action (deeper red via buttonColorClass) -->
      <button
        *ngIf="data.secondaryOption"
        mat-raised-button
        class="secondary-btn"
        [ngClass]="data.secondaryOption!.buttonColorClass"
        [disabled]="!isSecondaryEnabled"
        (click)="onSecondary()"
      >
        {{ data.secondaryOption!.buttonText }}
      </button>
    </div>
  </div>

</div>
